import { render, staticRenderFns } from "./TransactionTypeDetailsContainer.vue?vue&type=template&id=6f2d99f4"
import script from "./TransactionTypeDetailsContainer.vue?vue&type=script&lang=js"
export * from "./TransactionTypeDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports